export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 rounded-full mb-4">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-send-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs font-medium text-accent-700 whitespace-nowrap">
                  联系我们
                </span>
              </div>

              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
                与我们取得联系
              </h2>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                无论您有漫画资源需求、版权合作意向，还是想为51漫画下载平台提供建议与反馈，
                欢迎通过以下方式联系我们。5151漫画网团队将在24小时内回复您的信息。
              </p>

              <div className="flex flex-col gap-3 max-w-sm mx-auto lg:mx-0">
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-lg">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-primary-600 text-base"></i>
                  </div>
                  <div className="text-left min-w-0">
                    <p className="text-xs text-foreground-500">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800 truncate">contact@5151manga.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-lg">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                    <i className="ri-wechat-line text-accent-600 text-base"></i>
                  </div>
                  <div className="text-left min-w-0">
                    <p className="text-xs text-foreground-500">微信公众号</p>
                    <p className="text-sm font-medium text-foreground-800 truncate">5151漫画网</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-3 bg-background-50 rounded-lg">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                    <i className="ri-discuss-line text-secondary-600 text-base"></i>
                  </div>
                  <div className="text-left min-w-0">
                    <p className="text-xs text-foreground-500">读者交流群</p>
                    <p className="text-sm font-medium text-foreground-800 truncate">QQ群：888888888</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md">
              <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
                <p className="text-sm font-medium text-foreground-700 mb-4 text-center">
                  快速留言
                </p>
                <form className="space-y-3" onSubmit={(e) => e.preventDefault()}>
                  <input
                    type="text"
                    placeholder="您的昵称"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                  />
                  <textarea
                    placeholder="请描述您的需求或建议（500字以内）"
                    maxLength={500}
                    rows={3}
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors resize-none"
                  ></textarea>
                  <button
                    type="submit"
                    className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}